/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { IconButton } from "@mui/material";
import { ReactNode } from "react";
import { tiptapEditorToolbarButtonStyle } from "./tiptapEditorToolbarButtonStyle";

type TiptapEditorToolbarButtonProps = {
  onClick: () => void;
  isActive?: boolean;
  icon: ReactNode;
  label: string;
};

export const TiptapEditorToolbarButton = ({ onClick, isActive, label, icon }: TiptapEditorToolbarButtonProps) => {
  return (
    <IconButton onClick={onClick} aria-pressed={isActive} sx={isActive ? tiptapEditorToolbarButtonStyle.active : {}} aria-label={label}>
      {icon}
    </IconButton>
  );
};
